var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"navigation"},[_c('NavigationBar',{ref:"navigation_bar",attrs:{"id":"navigation_bar"}}),_c('div',{staticClass:"chunk",style:({ height: _vm.chunkHeight + 'px' })})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }